import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { createIssueGroup } from "../../../../../apis/options/IssueGroupApi";
import { getPlan } from "../../../../../apis/options/PlanApi";
import { useParams, useHistory } from "react-router-dom";
import { Card } from "react-bootstrap";

const schema = yup
  .object({
    name: yup.string().required(),
    planId: yup.number().required().positive().integer(),
    defaultIssueDate: yup.date(),
    defaultStrikePrice: yup.number(),
    defaultNumberOfShares: yup.number().positive().integer(),
    optionTypeId: yup.number().required().integer().positive()
  })
  .required()


export default function AddIssueGroupForm() {

  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  let { planId } = useParams();

  const history = useHistory();

  useEffect(() => {
    async function getPlanItem(id) {
      try {
        const result = await getPlan(id);
        setPlan(result);
        setLoading(false);
      }
      catch(err) {
        console.log(err);
        setLoading(false);
      }
    }

    getPlanItem(planId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const addIssueGroup = (data) => 
  {
    createIssueGroup(data)
    .then(_ => {
      history.push(`/options/plans/${planId}`);
    })
    .catch((error) => {
      history.push(`/options/plans/${planId}`);
    });
  }

  const cancelClick = () => {
    history.push(`/options/plans/${planId}`);
  }

  return (
    <>
    {loading ?
      <div>Loading...</div> :
      <Card>
        <Card.Title>New Issue Group</Card.Title>
        <Card.Text>
          <Form noValidate 
              onSubmit={handleSubmit(addIssueGroup)}>
                
              <Form.Group>
                <Form.Label>Issue Group Name</Form.Label>
                <Form.Control isInvalid={!!errors.name} type="text" placeholder="Issue Group Name" {...register("name")} />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Grant Date</Form.Label>
                <Form.Control isInvalid={!!errors.defaultIssueDate} type="date" placeholder="Default Grant Date" {...register("defaultIssueDate")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultIssueDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Strike Price</Form.Label>
                <Form.Control isInvalid={!!errors.defaultStrikePrice} type="text" placeholder="Default Strike Price" {...register("defaultStrikePrice")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultStrikePrice?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Number of Shares</Form.Label>
                <Form.Control isInvalid={!!errors.defaultNumberOfShares} type="text" placeholder="Default Number of Shares" {...register("defaultNumberOfShares")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultNumberOfShares?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Option Type</Form.Label>
                <Form.Control value="1" readOnly isInvalid={!!errors.optionTypeId} type="text" placeholder="Option Type" {...register("optionTypeId")} />
                <Form.Control.Feedback type="invalid">
                  {errors.optionTypeId?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Control value={plan.planId} type="hidden" {...register("planId")} />
              </Form.Group>                

              <Button variant="primary" type="submit">Add</Button>
              <Button variant="secondary" onClick={cancelClick}>Cancel</Button>
          </Form> 
        </Card.Text>
      </Card>
    }
    </>

  );
}